import axios from "axios"

export default {
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/ohseducation/update' : '/api/ohseducation/create',data)
        return response
    },
    async Table(data){
        const response = await axios.post('/api/ohseducation/table',data)
        return response
    },
    async Delete(id){
        const response = await axios.post(`/api/ohseducation/delete/${id}`)
        return response
    },
    async List(){
        const response = await axios.post('/api/ohseducation/list')
        return response
    },
    Employee:{
        async Create(data){
            const response = await axios.post('/api/ohseducation/employee/create',data)
            return response
        },
        async Table(data){
            const response = await axios.post('/api/ohseducation/employee/table',data)
            return response
        },
        async Report(data){
            const response = await axios.post('/api/ohseducation/employee/report',data)
            return response
        },
        async Dashboard(){
            const response = await axios.get('/api/ohseducation/employee/dashboard')
            return response
        },
        async Delete(id){
            const response = await axios.post(`/api/ohseducation/employee/delete/${id}`)
            return response
        },
        async Update(data) {
            const response = await axios.post('/api/ohseducation/employee/update', data);
            return response;
        },
    },

}